import { render, staticRenderFns } from "./second-delete-bulk-modal.vue?vue&type=template&id=dddb5812"
import script from "./second-delete-bulk-modal.ts?vue&type=script&lang=ts&external"
export * from "./second-delete-bulk-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./second-delete-bulk-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dddb5812')) {
      api.createRecord('dddb5812', component.options)
    } else {
      api.reload('dddb5812', component.options)
    }
    module.hot.accept("./second-delete-bulk-modal.vue?vue&type=template&id=dddb5812", function () {
      api.rerender('dddb5812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/second-delete-bulk-modal/second-delete-bulk-modal.vue"
export default component.exports